const condo_sec1_part2Object = (payload) => {
  return {
    type: "condosec1part2",
    payload,
  };
};

export default condo_sec1_part2Object;
